angular
  .module("myApp")

  .factory("listCache", function listCache($q, uuiData) {
    const TTL = 5 * 60 * 1000 // 5 min

    let data = {}
    let loadedAt = {}
    let pending = null

    const fresh = (view_name) => {
      return data[view_name] && Date.now() - loadedAt[view_name] < TTL
    }

    const load = (view_name, force = false) => {
      if (!force && fresh(view_name)) {
        return $q.resolve(data[view_name])
      }

      if (pending) {
        return pending
      }

      pending = $q((resolve, reject) => {
        uuiData.list(
          view_name,
          {},
          (result) => {
            data[view_name] = result
            loadedAt[view_name] = Date.now()
            pending = null
            resolve(data[view_name])
          },
          reject
        )
      })

      return pending
    }

    const invalidate = (view_name) => {
      data[view_name] = null
      loadedAt = 0
    }

    return {
      load,
      invalidate,
    }
  })

  .controller("MgrListController", function ($scope, $state, $stateParams, quickSearch, listCache, uuiData) {
    $scope.data = []
    $scope.ready = false
    $scope.filters = {}

    $scope.n_mine_all = 0
    $scope.n_mine_actionable = 0

    $scope.options_atbildigie = []
    $scope.options_pieteikumu_kartas = []

    const extra_filters_meta = {
      beigu_datums_no: ["Beigu datums", "no"],
      beigu_datums_lidz: ["Beigu datums", "līdz"],

      sakuma_datums_no: ["Sākuma datums", "no"],
      sakuma_datums_lidz: ["Sākuma datums", "līdz"],

      vp_no: ["Vidusposma atskaite", "no"],
      vp_lidz: ["Vidusposma atskaite", "līdz"],

      gp_no: ["Noslēguma atskaite", "no"],
      gp_lidz: ["Noslēguma atskaite", "līdz"],

      next_mp_no: ["MP termiņš", "no"],
      next_mp_lidz: ["MP termiņš", "līdz"],
    }

    $scope.extra_filters = []
    $scope.filters_open = false

    $scope.page_size = 20
    $scope.page_nr = 1

    this.updatePage = () => {
      const from = ($scope.page_nr - 1) * $scope.page_size
      const to = from + $scope.page_size
      $scope.page = $scope.filtered.slice(from, to)
      $scope.n_pages = Math.ceil($scope.filtered.length / $scope.page_size)
    }

    this.setPage = (n) => {
      if (n < 1 || n > $scope.n_pages) return

      $scope.page_nr = n
      this.updatePage()
    }

    const dateInRange = (value, from, to) => {
      if (from && (!value || value < from)) return false
      if (to && (!value || value > to)) return false
      return true
    }

    this.filter = (e) => {
      const f = $scope.filters

      if ((f.actionable === true || f.actionable === "true") && !e.needs_action) {
        return false
      }

      if (!dateInRange(e.sakuma_datums, f.sakuma_datums_no, f.sakuma_datums_lidz)) return false
      if (!dateInRange(e.beigu_datums, f.beigu_datums_no, f.beigu_datums_lidz)) return false
      if (!dateInRange(e.atskaite_vidusposms_datums, f.vp_no, f.vp_lidz)) return false
      if (!dateInRange(e.atskaite_noslegums_datums, f.gp_no, f.gp_lidz)) return false

      if (f.numbering_mode === "empty" && e.numurs) {
        return false
      }

      if (f.pieteikumu_karta && e.pieteikumu_karta_id !== f.pieteikumu_karta) {
        return false
      }

      if (f.next_mp_no || f.next_mp_lidz) {
        let kartas = e.mp_kartas.filter((k) => !e.maksajumi[k].is_paid)

        if (!f.mp_termins_mode) {
          kartas = kartas.slice(0, 1)
        }

        if (!kartas.some((k) => dateInRange(e.maksajumi[k].grafiks?.termins, f.next_mp_no, f.next_mp_lidz))) {
          return false
        }
      }

      if (f.pieteicejs && +f.pieteicejs !== e.sys_uznemums_id) {
        return false
      }

      if (f.atbildigais) {
        let found = false
        for (const a of e.atbildigie) {
          if (+a.adm_lietotajs_id === +f.atbildigais) {
            found = true
            break
          }
        }
        if (!found) {
          return false
        }
      }

      if (f.q && !quickSearch.matches_filter(e, f.q)) {
        return false
      }
      return true
    }

    const Today = new Date().toISOString().slice(0, 10)

    this.enrichMutable = (e) => {
      e.versijas_etc = e.versijas
        .filter((v) => v.id !== e.apstiprinata_versija_id)
        .filter((v) => v.statuss !== "NEAKTUALS")
        .filter((v) => v.statuss !== "MELNRAKSTS-VIDUSPOSMS")
        .filter((v) => v.statuss !== "MELNRAKSTS-LABOJUMS")
        .filter((v) => v.statuss !== "PROMOTED")
        .filter((v) => v.statuss !== "NETIKS-ISTENOTS")

      // nozīmīgās versijas, samaksāts + iesniegts
      e.mp_versijas_etc = e.mp_versijas.filter((v) => v.statuss !== "NEAKTUALS")

      if (e.apstiprinata_versija_id) {
        e.versija_apst = e.versijas.find((v) => v.id === e.apstiprinata_versija_id)
        if (e.versija_apst) {
          e.versija_apst.datums = e.versija_apst.vesture[e.versija_apst.vesture.length - 1].datums
        }
      }
      if (!e.apstiprinata_versija_id) {
        // nav apstiprinātās versijas, bet varbūt ir noraidītā
        const end_version = e.versijas_etc.find((v) => v.statuss === "NORAIDITS" || v.statuss === "LAUZTS")
        if (end_version) {
          e.versija_apst = end_version
          e.versijas_etc = e.versijas_etc.filter((v) => v.id !== end_version.id)
        }
      }

      let idx = 1
      for (const v of e.versijas) {
        v.last = v.vesture[v.vesture.length - 1]
        v.idx = `v${idx}`
        idx++
        if (!v.last) {
          v.last = {
            statuss: v.statuss,
            datums: null,
          }
        }
      }

      e.versijas_rev = e.versijas.toReversed()

      for (const v of e.mp_versijas) {
        v.last = v.vesture[v.vesture.length - 1]
        v.idx = v.pieprasijuma_numurs || "?"
        if (!v.last) {
          v.last = {
            statuss: v.statuss,
            datums: null,
          }
        }
      }
      e.mp_versijas_rev = e.mp_versijas.toReversed()

      let needs_action = false
      for (const v of e.mp_versijas) {
        if (v.statuss === "IESNIEGTS") {
          needs_action = true
        }
      }
      for (const v of e.versijas) {
        if (v.statuss === "IESNIEGTS") {
          needs_action = true
        }
      }
      e.needs_action = needs_action

      if (!e.lzp_pecdoktorants && e.versija_apst) {
        e.lzp_pecdoktorants = e.versija_apst.pecdoktorants_vards_uzvards
      }

      if (e.versija_apst) {
        // aizvācam vērtēšanas atbildīgos, viņi ir interesanti tikai, kamēr nav apstiprināts
        e.atbildigie = e.atbildigie.filter((a) => a.veids === "PIETEIKUMS")
      }

      // sakārtojam maksājumus, izveidojam kārtas_nr => { grafiks, maksājumi[]}
      e.maksajumi = {}

      // helperis
      const maksajums = (kartas_nr) => {
        if (!e.maksajumi[kartas_nr]) {
          e.maksajumi[kartas_nr] = {
            kartas_nr,
            grafiks: {},
            pieteikumi: [],
            is_paid: false,
          }
        }
        return e.maksajumi[kartas_nr]
      }

      // saliekam info pa plauktiņiem
      for (const v of e.mp_grafiks) {
        maksajums(v.npk).grafiks = v
      }
      for (const v of e.mp_versijas) {
        const m = maksajums(v.idx)
        m.pieteikumi.push(v)
        if (v.statuss === "SAMAKSATS") {
          m.is_paid = true
        }
      }
      e.mp_kartas = Object.keys(e.maksajumi)
        .map(Number)
        .toSorted((a, b) => a - b)

      const nesamaksata_karta = e.mp_kartas.find((karta) => !e.maksajumi[karta].is_paid)
      if (nesamaksata_karta) {
        // already ordered
        e.mp_unpaid = e.maksajumi[nesamaksata_karta]?.grafiks
        if (e.mp_unpaid) {
          e.mp_unpaid.is_late = e.mp_unpaid.termins < Today
        }
      }

      // search.js
      e.index = quickSearch.make_index([
        e.numurs,
        e.nosaukums,
        e.nosaukums_en,
        e.uzn_nosaukums,
        e.lzp_pecdoktorants,
      ])

      return e
    }

    this.prepareOptions = (all) => {
      const atbildigie = {}
      const pieteiceji = {}
      for (const p of all) {
        for (const a of p.atbildigie) {
          atbildigie[a.adm_lietotajs_id] = `${a.vards} ${a.uzvards}`
        }
        pieteiceji[p.sys_uznemums_id] = p.uzn_nosaukums
      }

      $scope.options_atbildigie = Object.entries(atbildigie)
        .map(([id, nosaukums]) => ({
          id,
          nosaukums,
        }))
        .toSorted((a, b) => a.nosaukums.localeCompare(b.nosaukums))

      $scope.options_pieteiceji = Object.entries(pieteiceji)
        .map(([id, nosaukums]) => ({
          id,
          nosaukums,
        }))
        .toSorted((a, b) => a.nosaukums.localeCompare(b.nosaukums))

      return listCache.load("pieteikumu_karta_select").then((data) => {
        $scope.options_pieteikumu_kartas = data.filter((d) => d.konkurss === "1.1.1.9")
      })
    }

    this.updateExtraFilters = () => {
      const f = $scope.filters
      $scope.extra_filters = []
      for (const k of Object.keys(extra_filters_meta)) {
        if (f[k]) {
          $scope.extra_filters.push({
            key: k,
            label: extra_filters_meta[k][0],
            pre: extra_filters_meta[k][1],
            value: moment(f[k]).format("DD.MM.YYYY"),
          })
        }
      }

      if (f.pieteikumu_karta) {
        const k = $scope.options_pieteikumu_kartas.find((k) => k.id === f.pieteikumu_karta)
        $scope.extra_filters.push({
          key: "pieteikumu_karta",
          label: "Kārta",
          value: k?.nosaukums ?? `${f.pieteikumu_karta}?`,
        })
      }
      if (f.numbering_mode) {
        $scope.extra_filters.push({
          key: "numbering_mode",
          label: "Pieteikumi",
          value: "nenumurētie",
        })
      }
    }

    this.removeFilter = (k) => {
      $scope.filters[k] = null
      this.applyFilters()
    }

    this.applyFilters = () => {
      const f = $scope.filters
      localStorage.setItem("nlist.pp.filter", JSON.stringify(f))
      $state.go(".", f, {
        notify: false,
        location: "replace",
      })

      this.updateExtraFilters()

      $scope.filtered = this.order($scope.data.filter(this.filter))
      this.updatePage()
    }

    this.order = (l) => {
      if ($scope.filters.sort === "pedejo_izmainu_datums") {
        return l.toSorted((a, b) => -a.pedejo_izmainu_datums.localeCompare(b.pedejo_izmainu_datums))
      }
      if ($scope.filters.sort === "numurs") {
        return l.toSorted((a, b) => -(a.numurs ?? "").localeCompare(b.numurs ?? ""))
      }
      if ($scope.filters.sort === "mp_termins") {
        return l.toSorted(
          (a, b) => +(a.mp_unpaid?.termins ?? "aa").localeCompare(b.mp_unpaid?.termins ?? "aa")
        )
      }
      console.log(`unknown sort mode: ${$scope.filters.sort}`)
      return l
    }

    this.dataReceived = (data) => {
      $scope.data = data
      data.forEach(this.enrichMutable)
      this.prepareOptions(data).then(() => {
        this.updateExtraFilters()
        $scope.filtered = this.order(data.filter(this.filter))

        $scope.n_mine_all = 0
        $scope.n_mine_actionable = 0
        data.forEach((d) => {
          if (d.atbildigie.find((a) => a.adm_lietotajs_id === $scope.u.id)) {
            $scope.n_mine_all++

            if (d.needs_action) {
              $scope.n_mine_actionable++
            }
          }
        })

        this.updatePage()
        $scope.ready = true
      })
    }

    this.filterMine = (actionable) => {
      $scope.filters = {
        actionable,
        atbildigais: $scope.u.id,
        sort: $scope.filters.sort,
      }
      this.applyFilters()
    }

    this.readFull = () => {
      listCache.load("pp_mgr_nlist").then(this.dataReceived)
    }

    this.initFilters = () => {
      const stored = JSON.parse(localStorage.getItem("nlist.pp.filter") || "{}")
      const routeParams = Object.fromEntries(
        Object.entries($stateParams).filter(([_k, v]) => v !== undefined && v !== null && v !== "")
      )
      const defaults = {
        actionable: true,
        q: "",
        sort: "pedejo_izmainu_datums",
      }
      const o = {
        ...defaults,
        ...stored,
        ...routeParams,
      }
      o.actionable = o.actionable === true || o.actionable === "true"
      if (o.pieteikumu_karta) {
        o.pieteikumu_karta = Number(o.pieteikumu_karta)
      }
      return o
    }

    $scope.filters = this.initFilters()

    this.readFull()
  })
